import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@mui/material";
import styles from "./primary-button.module.scss";
import clsx from "clsx";
export const PrimaryButton = (props) => (_jsx(Button, Object.assign({ classes: { root: clsx([props.className, styles.root]) }, variant: "contained", color: "primary" }, props, { children: props.children || props.text })));
